import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { ProofSection } from '../components/ProofSection';
import { LearnSection } from '../components/LearnSection';
import { ProgramDetails } from '../components/ProgramDetails';
import { MentorSection } from '../components/MentorSection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { BeforeSection } from '../components/BeforeSection';
import { AfterSection } from '../components/AfterSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { BonusSection } from '../components/BonusSection';
import { FaqAccordion } from '../components/FaqAccordion';
import { FinalMentorSection } from '../components/FinalMentorSection';
import { Footer } from '../components/Footer';
import { StickyRibbon } from '../components/StickyRibbon';
export function LandingPage() {
  return <div className="w-full min-h-screen flex justify-center bg-brand-lavender" data-id="element-245">
      <StickyRibbon data-id="element-246" />
      {/* Main Container */}
      <main className="w-full bg-gradient-to-b from-brand-lavender via-brand-lavenderLight to-brand-lavender relative overflow-x-hidden pt-[80px] md:pt-[120px]" data-id="element-247">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-white/40 to-transparent pointer-events-none z-0" data-id="element-248"></div>

        <HeroSection data-id="element-249" />
        <IntroSection data-id="element-250" />
        <ProofSection data-id="element-251" />
        <LearnSection data-id="element-252" />
        <ProgramDetails data-id="element-253" />
        <MentorSection data-id="element-254" />
        <PortfolioCarousel data-id="element-255" />
        <BeforeSection data-id="element-256" />
        <AfterSection data-id="element-257" />
        <TestimonialsSection data-id="element-258" />
        <BonusSection data-id="element-259" />
        <ModulesSection data-id="element-260" />
        <PricingSection data-id="element-261" />
        <FinalMentorSection data-id="element-262" />
        <FaqAccordion data-id="element-263" />
        <Footer data-id="element-264" />
      </main>
    </div>;
}